$eve_tab_container $eve_surface
	value? \
	spreads *
	spread_title* \
	option_selected* false
	option_click*?event null
	content /
	sub /
		<= Tabs $eve_tab_group
			value? <=> value?
			options <= tabs /
			option_label* <= spread_title*
			option_selected* <= option_selected*
			option_click*?event <=> option_click*?event
		<= Content $eve_surface
			sub <= content
